import React, { useState } from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { PageInfo } from '../../Header/PageInfo';
import { EntityId } from '@reduxjs/toolkit';
import { Typography } from '@material-ui/core';
import { Link as RouteLink } from 'react-router-dom';
import { generateRoute } from '../../../utils/location';
import { prettyCategories } from '../../../utils/transformationHelper';
import { useFetchAppCategoriesQuery } from '../../../redux/api/appMarket-api-slice';
import { SecondaryButton } from '@clover/web-lib-core/dist/components';
import { SuggestAppModal } from '../../SuggestAppModal';
import { AppMarketPageIdentifier } from '../../../AppRoutes';
import { SetPageTitle } from '../SetPageTitle';

type ComponentProps = {
  checkSearchString?: string;
};

export const NoResult: React.FC<ComponentProps> = ({ checkSearchString }): JSX.Element => {
  const { t } = useTranslation();
  const { data: categories, isLoading: categoriesLoading } = useFetchAppCategoriesQuery('');
  const [suggestApp, setSuggestApp] = useState(false);

  const checkModalState = () => {
    setSuggestApp(true);
  };

  return (
    <>
      <SetPageTitle />
      <PageInfo
        hideDescription={true}
        title={
          !!checkSearchString
            ? t('no_results_found.no_results_found_for', { searchString: `"${checkSearchString}"` })
            : t('no_results_found.no_results')
        }
        role='alert'
      />
      <div className={styles.container}>
        <div className={styles.header}>
          <Typography variant="inherit" role="note" tabIndex={0}>
            {' '}
            {!!checkSearchString ? t('browse_other.search') : t('browse_other.categories')}
          </Typography>
        </div>
        <div className={styles.menu}>
          <div id="displayCategory">
            {categories?.ids?.map((appCategoryId: EntityId) => (
              <Typography variant="body1" className={styles.menuItem} tabIndex={-1} key={appCategoryId}>
                <RouteLink
                  to={generateRoute(AppMarketPageIdentifier.Categories, appCategoryId as Uuid)}
                  key={appCategoryId}
                >
                  {prettyCategories(categories.entities[appCategoryId]?.name!, t)}
                </RouteLink>
              </Typography>
            ))}
          </div>
        </div>
      </div>
      {!categoriesLoading && (
        <div className={styles.footerAction}>
          <span>{t('no_results_found.still_cant_find')}</span>
          <SecondaryButton onClick={checkModalState} className={styles.button} data-testid='openSuggestAppModal'>
            {t('no_results_found.suggest_app')}
          </SecondaryButton>
        </div>
      )}
      <SuggestAppModal open={suggestApp} onClose={() => setSuggestApp(false)} />
    </>
  );
};
